import React from 'react';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';
import BaseQuillLayout, { QuillWysiwygLayoutProps } from './BaseQuillLayout';
import MaxLengthInfo from './MaxLengthInfo';
import styles from './ShadcnQuillWysiwyg.module.scss';

export default function ShadcnQuillWysiwygLayout(props: QuillWysiwygLayoutProps) {
  return (
    <ShadcnBaseInputLayout
      label={props.label}
      afterLabelElement={props.afterLabelElement}
      name={props.name}
      errors={props.errors}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
    >
      <div className={styles.shadcnWysiwyg}>
        <BaseQuillLayout {...props} />
        <MaxLengthInfo name={props.name} value={props.value || ''} />
      </div>
    </ShadcnBaseInputLayout>
  );
}
